"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerTextInputPlaceholder = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _DatePickerTextInputPlaceholderStyled = require("../styled/DatePickerTextInputPlaceholderStyled");
const DatePickerTextInputPlaceholder = _ref => {
  let {
    clientId,
    format,
    validationState,
    value,
    isFocused,
    focusMode,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_DatePickerTextInputPlaceholderStyled.DatePickerTextInputPlaceholderStyled, (0, _extends2.default)({
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, "dp-input-placeholder"),
    themeMode: themeMode,
    validationState: validationState,
    isFocused: isFocused,
    focusMode: focusMode
  }, rest), /*#__PURE__*/_react.default.createElement("span", {
    className: "sds__user-input"
  }, value), /*#__PURE__*/_react.default.createElement("span", {
    className: "sds__format-placeholder"
  }, format.substring(value.length)));
};
exports.DatePickerTextInputPlaceholder = DatePickerTextInputPlaceholder;
//# sourceMappingURL=DatePickerTextInputPlaceholder.js.map